export default __webpack_public_path__ + "static/media/Picture9.c86b0e6f.jpg";